<template>
  <ConselhoPage
    slug="funarpen-conselho-fiscal"
    titulo="Conselho Fiscal"
  />
</template>

<script lang="ts">
import ConselhoPage from '~/components/Lista.vue'
export default { components: { ConselhoPage } }
</script>

<script setup lang="ts">
definePageMeta({
  title: 'FUNARPEN - Conselho Fiscal',
  middleware: 'manutencao',
})

useHead({
  title: 'Conselho Fiscal',
  meta: [{ name: 'description', content: 'Conselho Fiscal' }],
})
</script>
